<template>
  <div class="w100 pl10 pt10 pb10 h100 score-container">
    <div class="head flex-box ju-sb">
      <div class="title-box flex-box">
        <div @click="changeTab('theme')" :class="`head-title ${activeTab === 'theme' ? 'active' : ''}`">按主题</div>
        <div @click="changeTab('department')" :class="`head-title ${activeTab === 'department' ? 'active' : ''}`">按部门</div>
      </div>
      <div class="shortcuts">
        <el-button 
          :type="activeShortcut.code===item.code?'primary':''"
          v-for="item in shortcutList"
          :key="item.code"
          @click="shortcutClick(item)"
        >{{item.title}}</el-button>
      </div>
      <div class="month-picker flex-box ju-c al-c">
        <el-date-picker
          v-model="dateRange"
          @change="handleDataChange"
          value-format="yyyy-MM-dd"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>
    <div class="content-body flex-box">
      <div class="left-menu">
        <div 
          v-if="activeTab === 'theme'"
          class="theme-menu"
          v-loading="themeLoading"
        >
          <div class="theme-list-box">
            <div class="theme-list" v-for="item in themeList" :key="item.id" @click="changeTheme(item)">
              <div :class="`theme-name ${activeTheme.id===item.id?'active':''}`">{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="page-box" v-if="activeTab === 'theme'">
          <el-pagination
            small
            layout="prev, pager, next"
            @current-change="commentPaginationChange"
            :pager-count="5"
            :current-page.sync="themePagination.current"
            :total="themePagination.total">
          </el-pagination>
        </div>
        <treeMenu
          treeWidth="200px"
          style="width: 100%"
          ref="treeMenu"
          initId="0"
          :isEdit="true"
          loadStyle="staticLoad"
          @nodeClick="nodeId"
          :showBox="false"
          :showArrow="false"
          v-else
        ></treeMenu>
      </div>
      <div class="score-box flex-1 h100">

        <div class="score-head">基础统计</div>
        <div class="base-box" v-loading="headLoading">
          <div>
            <div>线上办件数</div>
            <div>{{headData.handleCnt?headData.handleCnt:'-'}}<span>件</span></div>
          </div>
          <div>
            <div>收到差评数</div>
            <div>{{headData.badCnt?headData.badCnt:'-'}}<span>条</span></div>
          </div>
          <div>
            <div>差评整改率</div>
            <div>{{headData.reformCnt?headData.reformCnt:'-'}}<span>%</span></div>
            <div class="extra">部门向群众反馈整改结果</div>
          </div>
          <div>
            <div>平均分</div>
            <div>{{headData.serverAvgCnt?headData.serverAvgCnt:'-.-'}}<span>分</span></div>
            <div class="extra">
              <el-rate :value="Number(headData.serverAvgCnt)" disabled></el-rate>
            </div>
          </div>
        </div>

        <div class="score-head">TOP 统计</div>
        <div class="top-box" v-loading="topLoading">
          <div class="top5">
            <div class="title">好评最多TOP5</div>
            <div class="top5-list" v-for="item in goodTop5" :key="item.name">
              <div class="top5-item w100">
                <div class="info flex-box ju-sb">
                  <div>{{item.name}}</div>
                  <div>{{item.cnt}}</div>
                </div>
                <div>
                  <el-progress :percentage="handleTopProgress('good',item.cnt)" color="#4494F4" :show-text="false"></el-progress>
                </div>
              </div>
            </div>

            <template v-if="goodTop5.length<5">
              <div class="top5-list" v-for="item in (5 - goodTop5.length)" :key="item">
                <div class="top5-item w100">
                  <div class="info flex-box ju-sb">
                    <div></div>
                    <div>0</div>
                  </div>
                  <div>
                    <el-progress :percentage="0" color="#4494F4" :show-text="false"></el-progress>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="empty"></div>
          <div class="top5">
            <div class="title">吐槽最多TOP5</div>
            <div class="top5-list" v-for="item in badTop5" :key="item.name">
              <div class="top5-item w100">
                <div class="info flex-box ju-sb">
                  <div>{{item.name}}</div>
                  <div>{{item.cnt}}</div>
                </div>
                <div>
                  <el-progress :percentage="handleTopProgress('bad',item.cnt)" color="#F13B3A" :show-text="false"></el-progress>
                </div>
              </div>
            </div>
            
            <template v-if="badTop5.length<5">
              <div class="top5-list" v-for="item in (5 - badTop5.length)" :key="item">
                <div class="top5-item w100">
                  <div class="info flex-box ju-sb">
                    <div></div>
                    <div>0</div>
                  </div>
                  <div>
                    <el-progress :percentage="0" color="#4494F4" :show-text="false"></el-progress>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="score-head po-r">详细信息
          <div class="h100 flex-box al-c po-a cu-p" style="right:10px; bottom:0" title="导出" @click="exportExcle">
            <img :src="`${baseUrl}images/excel2.svg`" alt="" >
          </div>
        </div>
        <div class="detail-box" v-loading="commentLoading">
          <!-- <div class="detail-item flex-box" v-for="(item, index) in commentList" :key="index">
            <div class="detail-avatar">
              <img :src="item.avatar" alt="" v-if="item.avatar">
              <img :src="`${baseUrl}images/avatar.png`" alt="" v-else>
            </div>
            <div class="detail-content flex-1">
              <div class="top-item flex-box">
                <div class="mr20 ellipsis">{{item.name}}</div>
                <div>
                  <el-rate :value="item.rations" disabled></el-rate>
                </div>
              </div>
              <div class="bottom-item">{{item.content}}</div>
            </div>
            <div class="time">{{item.createTime}}</div>
          </div>
          <div v-if="commentList.length===0" class="empty">暂无数据</div> -->
          <el-table
            :data="commentList"
            style="width: 100%"
            @sort-change='sortChange'
          >
            <el-table-column prop="name" label="评价人" width="130px" align="center">
              <template slot-scope="scope">
                <div style="text-align:center">
                  <img :src="`${baseUrl}images/avatar.png`" alt="">
                  <div class="ellipsis">{{scope.row.privateFlag=='1'?scope.row.name:'匿名'}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="rations" label="评分" align="center" width="140px" sortable='custom'>
              <template slot-scope="scope">
                <div>
                  <el-rate :value="scope.row.rations" disabled></el-rate>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="deptName" label="部门" sortable='custom'></el-table-column>
            <el-table-column prop="serveName" label="评价服务" sortable='custom'></el-table-column>
            <el-table-column prop="content" label="评价内容"></el-table-column>
            <el-table-column prop="createTime" label="评价时间" align="center" width="160px"></el-table-column>
            <el-table-column prop="zt" label="状态" align="center" width="100px" sortable='custom'>
              <template slot-scope="scope">
                <span v-if="scope.row.handleFlag">已整改</span>
                <span :style="scope.row.rations<3?'color:red':''" v-else>{{ 3 > scope.row.rations ? '需整改' : '正常' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100px">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.rations<3 && !scope.row.handleFlag" @click="goReply(scope.row)">整改</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              @current-change="themePaginationChange"
              layout="prev, pager, next, total, jumper"
              :current-page.sync="commentPagination.current"
              :total="commentPagination.total">
            </el-pagination>
          </div>

          <el-dialog
            title="整改反馈"
            :visible.sync="dialogVisible"
            width="30%"
            @close="dialogClose"
          >
            <el-form
              :model="formValidate"
              :rules="ruleValidate"
              ref="formValidate"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="服务名称：">{{handleRow.serveName}}</el-form-item>
              <el-form-item label="所属部门：">{{handleRow.deptName}}</el-form-item>
              <el-form-item label="评价人：">{{handleRow.privateFlag=='1'?handleRow.name:'匿名'}}</el-form-item>
              <el-form-item label="评价内容：">{{handleRow.content}}</el-form-item>
              <el-form-item label="评分：">
                <el-rate :value="handleRow.rations" disabled></el-rate>
              </el-form-item>
              <el-form-item label="评价时间：">{{handleRow.createTime}}</el-form-item>
              <el-form-item label="整改结果：" prop="result">
                <el-input
                  type="textarea"
                  autosize
                  placeholder="请输入整改结果"
                  v-model="formValidate.result"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import treeMenu from "@/components/treeMenu/index.vue";
import {getSubjectList} from '@/api/managementCenter/themeManage'
import {queryRationPFVoList, queryRationHeadVo, queryRationGoodVoList, queryRationTuCaoVoList, submitRationHandle} from '@/api/management/score'
import request from '@/util/http'
import moment from 'moment';

export default {
  name: "Router",
  components: {
    treeMenu,
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      // month: '',
      dateRange: [],
      deptId: '',
      deptName: '',
      activeTab: 'theme',
      themeList: [],
      themePagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      commentPagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      headData: {
        handleCnt: '',
        badCnt: '',
        reformCnt: '',
        serverAvgCnt: '',
      },
      activeTheme: {},
      goodTop5: [],
      badTop5: [],
      commentList: [],
      themeLoading: false,
      headLoading: false,
      topLoading: false,
      commentLoading: false,
      shortcutList: [
        {code: 1, title: '今日'},
        {code: 2, title: '最近7天'},
        {code: 3, title: '最近30天'},
        {code: 4, title: '最近一年'},
        {code: 5, title: '去年'},
        {code: 6, title: '前年'},
      ],
      activeShortcut: {code: 2, title: '最近7天'},
      shortcutDateRange: [moment().subtract('days', 6).format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')],
      dialogVisible: false,
      ruleValidate: {
        result: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      formValidate: {
        result: '',
      },
      handleRow: {},
      typeIndex: '',
      typeOrderBy: '',
    };
  },
  computed: {},
  created() {
    this.initSubjectList()
  },
  mounted() {},
  destroyed() {},
  methods: {
    submit(){
      this.$refs.formValidate.validate((valid) => {
        if(valid){
          submitRationHandle({
            id: this.handleRow.id,
            result: this.formValidate.result
          })
          .then(({data}) => {
            if(data.code==0){
              this.$message.success('操作成功')
              this.initCommentList();
              this.dialogVisible = false
            }else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    sortChange({ prop, order }){
      this.typeOrderBy = order ? (order==='ascending'?1:0) : null
      this.typeIndex = function () {
        switch (prop) {
          case 'rations':
            return 2
          case 'deptName':
            return 3
          case 'serveName':
            return 4
          case 'zt':
            return 1
        }
      }()
      this.getCommentList()
    },
    dialogClose(){
      this.formValidate.result = '';
    },
    changeTab(tab){
      this.activeTab = tab;
    },
    nodeId(data) {
      this.deptId = data.id;
      this.deptName = data.name;
      this.initContent();
    },
    shortcutClick(item){
      this.activeShortcut = item;
    },
    initSubjectList(){
      this.themePagination.current = 1;
      this.getSubjectList(true);
    },
    getSubjectList(isInit){
      let obj = {
        current: this.themePagination.current,
        size: this.themePagination.size,
      }
      getSubjectList(obj)
      .then(({data}) => {
        if(data.code == 0){
          if(data.data.records.length && this.themePagination.current==1){
            data.data.records.unshift({id:null, name:'全部'})
          }
          this.themeList = data.data.records;
          this.themePagination.total = data.data.total;
          if(isInit){
            this.activeTheme = data.data.records[0] || {};
          }
        }
      })
    },
    getTop(){
      this.topLoading = true
      request.all([this.getGoodTop(), this.getBadTop()])
      .then((res) => {
        if(res[0].data.code !== 0){
          this.$message.error(res[0].data.msg);
        }else {
          this.goodTop5 = res[0].data.data
        }
        if(res[1].data.code !== 0){
          this.$message.error(res[1].data.msg);
        }else {
          this.badTop5 = res[1].data.data
        }
      }).finally(() => {
        this.topLoading = false
      })
    },
    getGoodTop(){
      let obj = {};
      if(this.shortcutDateRange.length){
        obj.begin_date = this.shortcutDateRange[0];
        obj.end_date = this.shortcutDateRange[1];
      }else if(this.dateRange){
        obj.begin_date = this.dateRange[0]
        obj.end_date = this.dateRange[1]
      }
      if(this.activeTab === 'theme'){
        obj.subject_id = this.activeTheme.id
      }else {
        obj.dept_id = this.deptId
      }
      return queryRationGoodVoList(obj)
    },
    getBadTop(){
      let params = {};
      if(this.shortcutDateRange.length){
        params.begin_date = this.shortcutDateRange[0];
        params.end_date = this.shortcutDateRange[1];
      }else if(this.dateRange){
        params.begin_date = this.dateRange[0]
        params.end_date = this.dateRange[1]
      }
      if(this.activeTab === 'theme'){
        params.subject_id = this.activeTheme.id
      }else {
        params.dept_id = this.deptId
      }
      return queryRationTuCaoVoList(params)
    },
    changeTheme(item){
      this.activeTheme = item;
    },
    handleTopProgress(type, num){
      if(type === 'good' && this.goodTop5.length>0){
        return num/this.goodTop5[0].cnt * 100
      } 
      if(type === 'bad' && this.badTop5.length>0){
        return num/this.badTop5[0].cnt * 100
      }
      return 0;
    },
    initCommentList(){
      this.commentPagination.current = 1;
      this.getCommentList()
    },
    getCommentList(){
      let obj = {
        current: this.commentPagination.current,
        size: this.commentPagination.size,
        typeIndex: this.typeIndex,
        typeOrderBy: this.typeOrderBy,
      }
      if(this.shortcutDateRange.length){
        obj.begin_date = this.shortcutDateRange[0];
        obj.end_date = this.shortcutDateRange[1];
      }else if(this.dateRange){
        obj.begin_date = this.dateRange[0]
        obj.end_date = this.dateRange[1]
      }
      if(this.activeTab === 'theme'){
        obj.subject_id = this.activeTheme.id
      }else {
        obj.dept_id = this.deptId
      }
      this.commentLoading = true;
      queryRationPFVoList(obj)
      .then(({data}) => {
        if(data.code == 0){
          this.commentList = data.data.records;
          this.commentPagination.total = data.data.total;
        }else {
          this.$message.error(data.msg);
        }
      }).finally(() => {
        this.commentLoading = false;
      })
    },
    themePaginationChange(current){
      this.commentPagination.current = current;
      this.getCommentList();
    },
    commentPaginationChange(current){
      this.themePagination.current = current;
      this.getSubjectList();
    },
    handleDataChange(){
      this.initContent();
    },
    initContent(){
      this.initCommentList();
      this.getHeadData();
      this.getTop();
    },
    getHeadData(){
      let params = {};
      if(this.shortcutDateRange.length){
        params.begin_date = this.shortcutDateRange[0];
        params.end_date = this.shortcutDateRange[1];
      }else if(this.dateRange){
        params.begin_date = this.dateRange[0]
        params.end_date = this.dateRange[1]
      }
      if(this.activeTab === 'theme'){
        params.subject_id = this.activeTheme.id
      }else {
        params.dept_id = this.deptId
      }
      this.headLoading = true;
      queryRationHeadVo(params)
      .then(({data}) => {
        if(data.code == 0){
          this.headData = data.data;
        }else {
          this.$message.error(data.msg);
        }
      }).finally(() => {
        this.headLoading = false;
      })
    },
    goReply(row){
      this.handleRow = row;
      this.dialogVisible = true;
    },
    exportExcle(){
      let params = {}
      if(this.shortcutDateRange.length){
        params.begin_date = this.shortcutDateRange[0];
        params.end_date = this.shortcutDateRange[1];
      }else if(this.dateRange){
        params.begin_date = this.dateRange[0]
        params.end_date = this.dateRange[1]
      }
      if(this.activeTab === 'theme'){
        params.subject_id = this.activeTheme.id
        params.subject_name = this.activeTheme.name
        params.dept_name = '全校'
      }else {
        params.dept_id = this.deptId
        params.dept_name = this.deptName
        params.subject_name = '全部'
      }
      this.$DownLoadL(
        `/admin/tHallServeRation/exportRationPFVoList?${this.$qs.stringify(params)}`,
        null,
        res => {
          if (res.status == 200) {
            // this.$message.success("开始下载");
          } else {
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        },
        error => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      );
    },
  },
  watch: {
    activeTheme(val){
      this.initContent()
    },
    activeTab(val){
      if(val === 'theme'){
        this.deptId = ''
      }else if(val === 'department'){
        this.deptId = '1'
        this.deptName = '全校'
      }
      this.initContent()
    },
    activeShortcut(val){
      if(val.code){
        this.dateRange = [];
        switch (val.code) {
          case 1:
            this.shortcutDateRange = [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]
            break;
          case 2:
            this.shortcutDateRange = [moment().subtract('days', 6).format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')];
            break;
          case 3:
            this.shortcutDateRange = [moment().subtract('days', 29).format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')];
            break;
          case 4:
            this.shortcutDateRange = [moment().subtract('days', 365).format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')];
            break;
          case 5:
            this.shortcutDateRange = [moment().year(moment().year() - 1).startOf('year').format('YYYY-MM-DD'),moment().year(moment().year() - 1).endOf('year').format('YYYY-MM-DD')];
            break;
          case 6:
            this.shortcutDateRange = [moment().year(moment().year() - 2).startOf('year').format('YYYY-MM-DD'),moment().year(moment().year() - 2).endOf('year').format('YYYY-MM-DD')];
            break;
          default:
            this.shortcutDateRange = [];
            break;
        }
        this.handleDataChange();
      }else {
        this.shortcutDateRange = [];
      }
    },
    dateRange(val){
      if(!val){
        this.activeShortcut = {code: 2, title: '最近7天'};
        return
      }
      if(val.length>0){
        this.activeShortcut = {};
      }
    }
  },
  filters: {}
};
</script>

<style scoped lang="less">
@import url("score.less");
</style>
